import type { Product } from './types';

export const AUNT_STATSIG_EXPERIMENT_KEY = 'auto_upgrade_not_a_trial';
export const STANDARD_TRIAL_DAYS_TO_DEACTIVATION = 14;
export const AVOID_DEACTIVATION_MODAL_TEST_ID = 'auto-upgrade-avoid-deactivation-modal';
export const AVOID_DEACTIVATION_MODAL_ACTION_SUBJECT_ID = 'autoUpgradeAvoidDeactivationModal';
export const AVOID_DEACTIVATION_BANNER_SUBJECT_ID = 'autoUpgradeAvoidDeactivationBanner';
export const AVOID_DEACTIVATION_BANNER_TEST_ID = 'auto-upgrade-avoid-deactivation-banner';
export const AVOID_DEACTIVATION_FLAG_ID = 'auto-upgrade-avoid-deactivation-flag';
export const ADD_PAYMENT_AVOID_DEACTIVATION_ACTION_SUBJECT_ID = 'addPaymentAvoidDeactivation';
export const REMOVE_USERS_AVOID_DEACTIVATION_ACTION_SUBJECT_ID = 'removeUsersAvoidDeactivation';
export const TAKE_ACTION_AVOID_DEACTIVATION_ACTION_SUBJECT_ID = 'autoUpgradeNotATrial';
export const TAKE_ACTION_SOURCE_ID = 'autoUpgradeNotATrial';
export const AVOID_DEACTIVATION_BANNER_HEIGHT = 44;

export const MAX_USERS_ON_FREE_PLAN: Record<Product, number> = {
	confluence: 10,
	'jira-product-discovery': 3,
	'jira-service-management': 3,
	jira: 10,
};

export const PRODUCT_TO_CHARGE_ELEMENT: Record<Product, string> = {
	['confluence']: 'user',
	['jira']: 'user',
	['jira-product-discovery']: 'creator',
	['jira-service-management']: 'agent',
};

export const PRODUCT_TO_ORIGIN: Record<Product, string> = {
	['confluence']: 'confluence',
	['jira']: 'jira',
	['jira-product-discovery']: 'jira',
	['jira-service-management']: 'jira',
};

export const ProductKeyToHAMSMap: Record<Product, string> = {
	['confluence']: 'confluence',
	['jira']: 'jira-software',
	['jira-product-discovery']: 'jira-product-discovery',
	['jira-service-management']: 'jira-servicedesk',
};
